import { app } from '@/main';
import flagKeys from '@/constants/flagKeys';
import { EOnboardingMeetingStatus } from '@/models/onboarding-call';
import { IBusinessType } from '@/models/business';
import { getMerchantMeetingOboardingState } from '@/router/router-utils';

export const getNeedsOnboardingCall = () => {
  const flags = app.$store.getters['flags/getFlags'] || [];
  const business = app.$store.getters['business/getBusinessInfo'].business;

  return !!(
    flags.includes(flagKeys.showOnboardingCallBanner) &&
    business &&
    business.onboardingMeeting &&
    business.onboardingMeeting.status !== EOnboardingMeetingStatus.COMPLETED
  );
};

export const getShowOnboardingCallBanner = () => {
  const flags = app.$store.getters['flags/getFlags'] || [];
  const business = app.$store.getters['business/getBusinessInfo'].business;

  return !!(
    flags.includes(flagKeys.showOnboardingCallBanner) &&
    business &&
    [IBusinessType.INSTORE, IBusinessType.BOTH].includes(business.type) &&
    (getMerchantMeetingOboardingState() ||
      (business.onboardingMeeting &&
        !business.onboardingMeeting.isConfirmedBannerViewed))
  );
};
